/** @format */

import React, { useMemo, useState } from 'react';
import I18n from '../../../components/Translate/I18n';
import { InvoiceInterface } from '../../../interfaces/platform/InvoiceInterface';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import { KsefErrorDataByDate } from '../../../interfaces/ksef/KsefErrorData';
import { KsefErrorShortDescription } from './KsefErrorShortDescription';
import { KsefErrorDialog } from './KsefErrorDialog';
import ViewButton from '../../../components/Buttons/ViewButton';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';

type KsefErrorType = {
    classes: any;
    invoice: InvoiceInterface;
};

export const KsefError = (props: KsefErrorType): React.ReactElement => {
    const classes   = props.classes;
    const {invoice} = props;
    const [errorParsingError, setErrorParsingError] = useState<boolean>(false);
    const [errorDialogOpen, setErrorDialogOpen] = useState<boolean>(false);

    const openErrorDialog = (): void => {
        setErrorDialogOpen(true);
    };
    const closeErrorDialog = (): void => {
        setErrorDialogOpen(false);
    }

    const sortKsefErrorDataByDate = (data: KsefErrorDataByDate): KsefErrorDataByDate => {
        const sorted: KsefErrorDataByDate = {};

        Object.keys(data)
            .sort()
            .reverse()
            .forEach(key => {
                sorted[key] = data[key];
            });

        return sorted;
    }

    const correctKsefErrorDataByDate = (x: unknown): x is KsefErrorDataByDate => {
        return typeof x === "object" && x !== null;
    };

    const ksefError = useMemo((): null | KsefErrorDataByDate => {
        let tmp: any = null;

        try {
            if(invoice.ksefError) {
                tmp = JSON.parse(invoice.ksefError);
            }
        } catch (e) {
            setErrorParsingError(true);
            tmp = null;
        }

        if (tmp && correctKsefErrorDataByDate(tmp)) {
            const sortedTmp: KsefErrorDataByDate = sortKsefErrorDataByDate(tmp);
            setErrorParsingError(false);
            return sortedTmp as KsefErrorDataByDate;
        }

        if(tmp && !correctKsefErrorDataByDate(tmp)) {
            setErrorParsingError(true);
        }

        return null;
    }, [invoice.ksefError]);

    return (
        <>
            {errorParsingError && (
                <I18n trans={"documents:invoices.ksefErrorParser.parsingError"} />
            )}
            {!ksefError && (<></>)}
            {ksefError && (<>
                <GridContainer style={{minWidth: '400px', textWrap: 'auto'}}>
                    <GridItem xs={1}>
                        <ViewButton callback={openErrorDialog} callbackParam={{}} />
                    </GridItem>
                    <GridItem xs={10}>
                        <KsefErrorShortDescription classes={classes} ksefErrorDataByDate={ksefError} />
                    </GridItem>
                </GridContainer>
                <KsefErrorDialog classes={classes} dialogOpen={errorDialogOpen} closeCallback={closeErrorDialog} ksefErrorDataByDate={ksefError} />
            </>)}
        </>
    );
};

export default withStyles(oplAppStyle)(KsefError);
